import React from 'react';
import Header from "../../header/Header";
import TimerCart from "../timer-cart/TimerCard";
import IconName from "../../../svgLogo/SvgLogo";
import Footer from "../../footer/Footer";

const SingleBundlePage = () => {
    return (
        <div className="single-bundle-page-wrapper">
            <Header/>
            <div className="product-title-responsive d-block d-lg-none xpy-4 xpx-6"><h1 className="title">گوشی موبایل
                اپل مدل iPhone 11 A2223 دو سیم‌ کارت ظرفیت 128 گیگابایت</h1></div>
            <div className="container xpt-14 xpt-lg-0">
                <div className="single-bundle-content">
                    <TimerCart dataTime="april 29, 2022 20:40:00" theme="purple-dark-timer"/>
                    <h1 className="bundle-title d-none d-lg-block">گوشی موبایل اپل مدل iPhone 11 A2223 دو سیم‌ کارت
                        ظرفیت 128
                        گیگابایت</h1>
                    <div
                        className="bundle-box d-flex align-items-center justify-content-between flex-column flex-lg-row xmt-8 xmt-lg-10 xmb-10">
                        <div className="product-item">
                            <div
                                className="price-box d-flex align-content-center justify-content-between position-absolute">
                                <span className="discount persian-number">۳۹،۴۵۹،۰۰۰ ت</span>
                                <span className="price persian-number">۳۸،۹۵۹،۰۰۰ ت</span>
                            </div>
                            <div className="product-img">
                                <img src="./assets/sample-image/kuang3.png" alt="image"/>
                            </div>
                            <h2 className="product-name">Apple iPhone 12 Dual SIM 128/4GB</h2>
                            <div className="color-range">
                                <span className="color active" style={{backgroundColor: "#4B9CF5"}}></span>
                                <span className="color" style={{backgroundColor: "#7575F1"}}></span>
                                <span className="color" style={{backgroundColor: "#A873DF"}}></span>
                            </div>
                        </div>
                        <div className="plus-icon xmy-6 xmy-lg-0">
                            <IconName name="add" className="icon"/>
                        </div>
                        <div className="product-item">
                            <div
                                className="price-box d-flex align-content-center justify-content-between position-absolute">
                                <span className="discount persian-number">۳۹۹،۰۰۰ ت</span>
                                <span className="price persian-number">۲۳۹،۰۰۰ ت</span>
                            </div>
                            <div className="product-img">
                                <img src="./assets/sample-image/iphoneCover.png" alt="image"/>
                            </div>
                            <h2 className="product-name">Tech21 iPhone 12 Evo Slim Case</h2>
                            <div className="color-range">
                                <span className="color active" style={{backgroundColor: "#506176"}}></span>
                                <span className="color" style={{backgroundColor: "#DA7B11"}}></span>
                                <span className="color" style={{backgroundColor: "#F76D74"}}></span>
                            </div>
                        </div>
                        <div className="plus-icon xmy-6 xmy-lg-0">
                            <IconName name="add" className="icon"/>
                        </div>
                        <div className="product-item">
                            <div
                                className="price-box d-flex align-content-center justify-content-between position-absolute">
                                <span className="discount persian-number">۳۹،۴۵۹،۰۰۰ ت</span>
                                <span className="price persian-number">۳۸،۹۵۹،۰۰۰ ت</span>
                            </div>
                            <div className="product-img">
                                <img src="./assets/sample-image/MWP22.png" alt="image"/>
                            </div>
                            <h2 className="product-name">Apple AirPods Pro</h2>
                            <div className="color-range">
                                <span className="color" style={{backgroundColor: "#EFF3F5"}}></span>
                            </div>
                        </div>
                    </div>
                    <div
                        className="button-box position-relative xmt-14 text-center d-flex align-items-center justify-content-center d-none d-lg-flex">
                        <div className="total-discount persian-number"><span
                            className="text">جمع تخفیف ۱،۳۲۹،۰۰۰ ت</span></div>
                        <div className="total-price persian-number xmr-6"><IconName name="library_add"
                                                                                    className="icon"/><span
                            className="text">خرید ۴۴،۸۴۷،۰۰۰ ت</span></div>
                        <div className="share-button position-absolute"><IconName name="share" className="icon"/></div>
                    </div>
                </div>
            </div>
            <div className="buy-button-responsive d-flex d-lg-none"><IconName name="library_add" className="icon position-absolute"/>
                <span className="text persian-number">خرید ۴۴،۸۴۷،۰۰۰ ت</span></div>
            <Footer/>
        </div>
    );
};

export default SingleBundlePage;
